<template>
  <div>
    <h1>Inventory Search For {{ls.location}}</h1>
    <!-- <select v-model="ls.location">
      
      <option v-for="l in locations" :key="l" v-bind:value="l">{{l}}</option>
    </select> -->

    Select Location: <LocationSelector v-model="ls.location" />
    
    <h5>Inventory</h5>
    <InventoryCRUD :location="ls.location" :departments="departments"/>
    
    <h5>Categories</h5>
    <CategoriesCRUD :location='ls.location'/>
    
    <h5>Departments</h5>
    <DepartmentsCRUD v-model='departments' :location='ls.location'/>

  </div>
</template>

<script>
import InventoryCRUD from '@/pages/Inventory/Components/InventoryCRUD.vue'
import CategoriesCRUD from '@/pages/Inventory/Components/CategoriesCRUD.vue'
import DepartmentsCRUD from '@/pages/Inventory/Components/DepartmentsCRUD.vue'
import localstorageMixin from '@/mixins/localstorageMixin.js'
// import LocationSelector from '@/components/LocationSelector.vue'
export default {
  mixins: [localstorageMixin],
  components : {InventoryCRUD, CategoriesCRUD, DepartmentsCRUD},
  name: 'InventorySearch',
  data () { return { 
    ls: {
      location: 'RMGB',
    },
    departments: {}
    } 
  },
  async created () {
    console.log('router', this.$router)
    console.log('route', this.$route)
    this.loadData();
  },
  watch:{
    "ls.location" : function(){
      console.log("location change")
      this.loadData();
    }
  },
  methods : {
    loadData: function(){
      
    },
  }, 
}
</script>

<style scoped>
  
</style>
